import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

const PasswordSent = () => (
	<Fragment>
		<div className="container-fluid">
			<div className="row justify-content-center">
				{/* main content area */}
				<main className="login-box col col-12 col-xs-12 col-sm-10 col-md-9 col-lg-5 col-xl-5">
					<h1 className="text-center mt-5 pt-3">
						<Link to="/">
							<img
								src={require('../assets/logo_school.png')}
								alt="ui distant learning logo"
								width={190}
								height="auto"
							/>
						</Link>
					</h1>
					{/* card for login box */}
					<div className="row no-gutters">
						<div className="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
							<div className="card min-h-auto">
								<div className="card-body p-0">
									<form>
										<div className="login-form">
											<div className="password-reset-info text-center">
												We just sent a random generated password to your email
											</div>
											<div className="password-reset-text text-center">
												I didn’t get reset email?{' '}
												<button className="btn btn-primary-small btn-primary btn-primary-color ml-2">
													Resend Email
												</button>
											</div>
											<div className="login-container text-center mt-5">
												<div className="forgot-password">
													<Link to="/login">
														Got your password? Go to Login Page
													</Link>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
						</div>
					</div>
					{/* end card for login box  */}
				</main>
				{/* main content area */}
			</div>
		</div>
	</Fragment>
);

export default PasswordSent;
